import React, { useEffect, useState } from 'react'
import api from '../../controller/api'
import { toast, Toaster } from "sonner"
import { useNavigate } from "react-router-dom"
import Loading from "../../components/Loading"
import { useDispatch } from 'react-redux';
import { couponData } from '../../features/offerSlice';
import { CouponData } from '../../components/Tables'
import Button from '@mui/material/Button';

export default function CouponList() {
    const [coupon, setCoupon] = useState([])
    const [pageLoading, setPageLoading] = useState(false)

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const handleStatus = async (id) => {
        try {
            await api.put("/coupon/ChangeStatus", { id })
            getCoupon()
        } catch (error) {
            console.error(error)
            toast.error(error?.response?.data?.message)
        }
    }

    const handleDisplay = async (id) => {
        try {
            await api.put("/coupon/coupon-display", { id })
            getCoupon()

        } catch (error) {
            console.error(error)
            toast.error(error?.response?.data?.message)
        }
    }

    const getCoupon = async () => {
        try {
            const { data: res } = await api.get("/coupon/list")
            setCoupon(res.data.reverse())
            const result = res.data.find((item) => item.couponShow === true)
            dispatch(couponData(result))
        } catch (error) {
            console.error(error?.response?.data?.message);
            if (error?.response?.data?.message === "jwt expired") {
                localStorage.removeItem("user");
                window.location.reload();
            }
        } finally {
            setPageLoading(false)
        }
    }

    const deleteCoupon = async (id) => {
        try {
            setPageLoading(true)
            await api.delete(`/coupon/delete/${id}`)
            toast.success("Coupon deleted")
            getCoupon()
        } catch (error) {
            console.error(error)
            toast.error(error?.response?.data?.message)
        } finally {
            setPageLoading(false)
        }
    }

    useEffect(() => {
        setPageLoading(true)
        getCoupon()

    }, [])

    if (pageLoading) return <Loading />

    return (
        <div className='table-data'>
            <Toaster richColors position="top-center" />
            <div className='manage'>
                <h2 style={{ display: "flex", justifyContent: "space-between" }}>
                    Coupon List
                    <Button variant="contained" onClick={() => navigate("/dashboard/coupon-create")}>Add Coupon</Button>
                </h2>
                <CouponData coupon={coupon} deleteCoupon={deleteCoupon} handleStatus={handleStatus} handleDisplay={handleDisplay} getCoupon={getCoupon} />
            </div>
        </div>
    )
}
